import { all, put, select } from 'redux-saga/effects';
import { initBrowseStream, deselectAll, unsetCurrentFolderId, initGallectionDeviationStream } from '../actions';
import { MediaSourceType } from '../types';
import { getCurrentMediaSource } from '../selectors';
export default function*() {
    const mediaSource = yield select(getCurrentMediaSource);
    const actionsToPut = [
        deselectAll(),
        unsetCurrentFolderId()
    ];
    if (mediaSource === MediaSourceType.GALLERY || mediaSource === MediaSourceType.COLLECTION) {
        actionsToPut.push(initGallectionDeviationStream());
    } else if (mediaSource === MediaSourceType.BROWSE) {
        actionsToPut.push(initBrowseStream());
    }
    yield all(actionsToPut.map((actionToPut)=>put(actionToPut)));
}
